import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(25)} 0;
`;

export const Title = styled.div`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: block;
    padding-bottom: ${rem(15)};
    color: ${({ theme }) => theme.colors.black};
`;

export const Capitols = styled.div`
    padding-bottom: ${rem(40)};
`;

export const Capitol = styled.div`
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.black};
    align-items: center;
    padding-top: ${rem(10)};
    cursor: pointer;
`;

export const CapitolTime = styled.span`
    width: ${rem(70)};
`;

export const CapitolIcon = styled(IconTemplate)`
    padding: 0 ${rem(25)} 0 ${rem(10)};

    svg {
        width: ${rem(20)};
        height: ${rem(20)};

        path {
            fill: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const CapitolTitle = styled.span``;